import { RadioGroup } from '@thanx/uikit/radio'
import { Text } from '@thanx/uikit/text'
import RichSelector from 'components/Form/RichSelector'
import ModalContainer from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  closeImportModeModal,
  confirmImportMode,
  selectImportModeModalOpen,
} from 'slices/userLists'
import type { ImportMode } from 'slices/userLists'
import ImportRowLimitNote from './ImportRowLimitNote'

const t = buildTranslate('user_lists.import_mode_modal')

const ImportModeModal: React.FC = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(state => selectImportModeModalOpen(state as any))
  const [selectedMode, setSelectedMode] = useState<ImportMode>('update')

  const handleContinue = () => {
    dispatch(confirmImportMode(selectedMode))
  }

  const handleClose = () => {
    setSelectedMode('update')
    dispatch(closeImportModeModal())
  }

  return (
    <ModalContainer
      isOpen={isOpen}
      title={t('title')}
      onClose={handleClose}
      onProceed={handleContinue}
      proceedText={t('continue')}
      zIndex={1002}
    >
      <Text.BodyText4 color="grey70" tag="p" className="mt-s mb-0 font-italic">
        {t('info_note')}
      </Text.BodyText4>
      <ImportRowLimitNote className="mt-xs mb-0" />
      <RadioGroup value={selectedMode}>
        <RichSelector
          value="update"
          className="mb-s mt-m"
          onClick={() => setSelectedMode('update')}
        >
          <Text.Header4 bold className="mt-xxs">
            {t('update_title')}
          </Text.Header4>
          <Text.BodyText4 color="grey70" tag="p" className="mb-0">
            {t('update_description')}
          </Text.BodyText4>
        </RichSelector>
        <RichSelector
          value="replace"
          onClick={() => setSelectedMode('replace')}
        >
          <Text.Header4 bold className="mt-xxs">
            {t('replace_title')}
          </Text.Header4>
          <Text.BodyText4 color="grey70" tag="p" className="mb-0">
            {t('replace_description')}
          </Text.BodyText4>
        </RichSelector>
      </RadioGroup>
    </ModalContainer>
  )
}

export default ImportModeModal
